export { default } from './svg/trash.svg';
